<template>
	<div class="c-page-header" ref="pageHeader" id="pageHeader">
		<div class="c-page-header__wrapper" role="banner">
			<div class="o-width-limiter">
				<div class="c-page-header__inner">
					<slot name="mkb-logo"></slot>
					<nav
						class="c-page-header__nav t-display--md"
						aria-label="Huvudnavigering"
					>
						<ul class="c-page-header__nav__list">
							<li
								:class="[
									{
										'c-page-header__nav__item--active':
											activeItemId === index &&
											showSubMenu
									},
									'c-page-header__nav__item'
								]"
								v-for="(link, index) in shortCutLinks"
								:key="index"
							>
								<button
									:id="'item-' + index"
									class="c-page-header__nav__button"
									:aria-controls="activeItemId === index ? 'content-' + index : null"
									:aria-expanded="
										activeItemId === index && showSubMenu
									"
									@click="(e) => handleClick(e, index)"
								>
									<v-icon
										:name="link.icon"
										size="m"
										css-modifiers=""
									></v-icon>
									<span
										class="c-page-header__nav__button-text"
										>{{ link.name }}</span
									>
								</button>
							</li>
						</ul>
					</nav>
					<div class="c-page-header__button-wrapper">
						<v-search-pane
							:url="searchPageUrl"
							:apiUrl="searchApiUrl"
							:searchButtonText="searchButtonText"
							:searchPlaceholder="searchPlaceholder"
							:performSearchText="performSearchText"
							className="c-page-header__search"
							:isActive.sync="showSearchPane"
						/>
						<div>
							<a
								:href="myPagesUrl"
								class="c-page-header__button--round c-page-header__my-pages"
							>
								<v-icon name="icon-user" size="s" />
								‍<span class="t-visually-hidden"
									>Mina sidor</span
								>
							</a>
						</div>
						<v-mobile-menu
							:links="links"
							:isActive.sync="showMobileMenu"
							:menuButtonText="menuButtonText"
							:closeMenuButtonText="closeMenuButtonText"
							className="c-page-header__mobile-menu"
						/>
					</div>
				</div>
			</div>
		</div>
		<Transition name="fade">
			<div
				class="c-page-header__subnav"
				:id="'content-' + activeItemId"
				:aria-hidden="showSubMenu ? 'false' : 'true'"
				v-if="showSubMenu"
				ref="subnav"
			>
				<ul
					class="o-width-limiter o-width-limiter--main c-page-header__subnav__list"
				>
					<li
						v-if="links"
						v-for="(sublink, index) in links[activeItemId].pages"
						class="c-page-header__subnav__item"
						:key="index"
					>
						<a
							:href="sublink.url"
							:aria-current="sublink.selected ? 'true' : 'false'"
							:class="[
								{
									'c-page-header__subnav__link--active':
										sublink.selected
								},
								'c-page-header__subnav__link'
							]"
						>
							{{ sublink.name }}
						</a>
					</li>
				</ul>
			</div>
		</Transition>
	</div>
</template>

<script>
import VIcon from "../../components/icon/VIcon.vue";
import VMobileMenu from "../../components/mobile-menu/VMobileMenu.vue";
import VSearchPane from "../../components/search-pane/VSearchPane.vue";

export default {
	name: "VPageHeader",
	components: {
		VIcon,
		VMobileMenu,
		VSearchPane
	},
	props: {
		links: {
			type: Array,
			default: () => []
		},
		shortCutLinks: {
			type: Array,
			default: () => []
		},
		searchPageUrl: { type: String, default: "" },
		searchApiUrl: { type: String, default: "" },
		searchButtonText: { type: String, default: "" },
		searchPlaceholder: { type: String, default: "" },
		performSearchText: { type: String, default: "" },
		myPagesUrl: { type: String, default: "" },
		menuButtonText: { type: String, default: "" },
		closeMenuButtonText: { type: String, default: "" }
	},
	data() {
		return {
			activeItemId: undefined,
			showSubMenu: false,
			showSearchPane: false,
			showMobileMenu: false,
			startY: 0,
			triggerButton: null,
			menuItems: [],
		};
	},
	mounted() {
		let selectedItemIndex = this.links.findIndex(item => item.selected);
		if (selectedItemIndex !== -1) {
			this.activeItemId = selectedItemIndex;
			this.showSubMenu = true;
		}
		this.focusConstraint();
	},
	watch: {
		showMobileMenu: function(value) {
			this.showSearchPane = false;
		},
	},
	methods: {
		handleClick: function(e, index) {
			if (this.activeItemId !== index) {

				this.activeItemId = index;

				this.showSubMenu = true;

				this.$nextTick(() => {

					this.triggerButton = e.currentTarget;
					this.focusConstraint();

				})
			} else if (this.activeItemId === index) {
				this.showSubMenu = !this.showSubMenu;
			}
		},
		focusConstraint: function() {
			if (this.$refs.subnav) {
				let children = Array.from(this.$refs.subnav.getElementsByTagName("a"));

				children.forEach(el => this.menuItems.push(el));
				if (children.length > 0) {
					children[children.length - 1].addEventListener('blur', () => {
						this.triggerButton.focus();
						this.showSubMenu = false;
					})
						children[0].focus();
					}
				}
		}
		// handleScroll: function() {
		// 	var scrollY = window.scrollY;
		// 	if (scrollY === 0) {
		// 		this.$refs.pageHeader.classList.remove("is-visible");
		// 		this.$refs.pageHeader.classList.remove("activated");
		// 		this.$refs.pageHeader.classList.remove("deactivated");
		// 	} else if (scrollY > this.startY) {
		// 		this.$refs.pageHeader.classList.remove("activated");
		// 		this.$refs.pageHeader.classList.add("is-visible");
		// 		this.$refs.pageHeader.classList.add("deactivated");
		// 	} else {
		// 		this.$refs.pageHeader.classList.remove("deactivated");
		// 		this.$refs.pageHeader.classList.add("activated");
		// 	}
		// 	this.startY = scrollY;
		// }
	}
	// mounted: function() {
	// 	window.addEventListener("scroll", this.handleScroll);
	// },
	// destroyed: function() {
	// 	window.removeEventListener("scroll", this.handleScroll);
	// }
};
</script>
